<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader
            style="background-color: #145654"
            class="border-bottom d-flex justify-content-between align-items-center px-3"
          >
            <h4 class="card-title mb-0 text-white d-flex align-items-center" style="font-size: 1.1rem;">
              <CIcon name="cil-window-restore" size="xl" class="mr-2"/> {{ $t('reportList.pageTitle') }}
            </h4>
            <button class="report-btn" @click="checkBeforeReport">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="12" y1="18" x2="12" y2="12" />
                <line x1="9" y1="15" x2="15" y2="15" />
              </svg>
              <span>{{ $t('reportList.newRequest') }}</span>
            </button>
          </CCardHeader>

          <CCardBody>
            <div class="custom-tabs">
              <div class="tabs-scroll-container">
                <div class="tabs-header">
                  <button :class="['tab-item', { active: activeTab === 'report' }]" @click="switchTab('report')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                  <span style="font-size: 15px; font-weight: 500">{{ $t('reportList.tabActive') }}</span>
                </button>
                  <button :class="['tab-item', { active: activeTab === 'history' }]" @click="switchTab('history')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                  </svg>
                  <span style="font-size: 15px; font-weight: 500">{{ $t('reportList.tabHistory') }}</span>
                </button>
                </div>
              </div>

              <div class="tabs-content mt-3">
                <div v-show="activeTab === 'report'" class="tab-panel table-responsive-wrapper">
                  <Sreportable 
                    ref="ureportTable"
                    @show-detail="handleShowDetail" 
                    @assign-task="handleShowDetail" 
                  />
                </div>
                <div v-show="activeTab === 'history'" class="tab-panel table-responsive-wrapper">
                  <Shistorytable ref="uhistoryTable" :lazy="true" @show-detail="handleShowDetail" />
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>

        <div id="detail-section" v-if="selectedReport" class="mt-4 mb-5">
          <ReportDetail
            :report="selectedReport"
            :is-assign-mode="isAssignMode"
            :is-reporter="selectedReport && selectedReport._role === 'reporter'"
            @close="closeDetail"
            @refresh="refreshTables"
            @ticket-updated="handleTicketUpdated"
          />
        </div>
      </CCol>
    </CRow>

    <SendReport v-model="sendReportModal" @ticket-created="handleTicketCreated" />
  </div>
</template>

<script>
import Shistorytable from "../../components/supervisor/Shistorytable.vue";
import Sreportable from "../../components/supervisor/Sreportable.vue";
import ReportDetail from "./ReportDetail.vue";
import SendReport from "../../components/user/SendReport";
import { getSocket } from "../../service/socketio.service";
import Swal from 'sweetalert2';

export default {
  name: "Dashboard",
  components: {
    Sreportable,
    Shistorytable,
    ReportDetail,
    SendReport,
  },
  data() {
    return {
      activeTab: "report",
      selectedReport: null,
      sendReportModal: false,
      isAssignMode: false, 
      historyLoaded: false,
    };
  },
  mounted() {
    this.setupSocketListeners();
  },
  beforeDestroy() {
    const socket = getSocket();
    if (socket) {
      socket.off("supervisor_ticket_updated");
      socket.off("supervisor_ticket_rejected");
    }
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'history' && !this.historyLoaded) {
        this.historyLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.uhistoryTable && typeof this.$refs.uhistoryTable.loadHistoryTickets === 'function') {
            this.$refs.uhistoryTable.loadHistoryTickets();
          }
        });
      }
    },
    setupSocketListeners() {
      const socket = getSocket();
      if (socket) {
        socket.off("supervisor_ticket_updated");
        socket.off("supervisor_ticket_rejected");

        socket.on("supervisor_ticket_updated", (data) => {
          this.refreshTables();
          if (this.selectedReport && this.selectedReport._id === data._id) {
            if (data.status === 'cancelled') {
              this.selectedReport = null;
              this.isAssignMode = false;
              Swal.fire({
                icon: 'info',
                title: this.$t('mainuser.ticketCancelledTitle'),
                text: this.$t('mainuser.ticketCancelledText'),
                confirmButtonColor: '#3085d6',
              });
            } else {
              this.selectedReport = { ...this.selectedReport, ...data };
            }
          }
        });

        socket.on("supervisor_ticket_rejected", (data) => {
          this.refreshTables();
          const title = this.$t('ticketDetail.tech.rejectedAlertTitle') || 'ช่างปฏิเสธงานซ่อม';
          const techLabel = this.$t('ticketDetail.tech.rejectedByLabel') || 'ช่างผู้ปฏิเสธ:';
          const reasonLabel = this.$t('ticketDetail.tech.rejectedReasonLabel') || 'เหตุผล:';
          const ticketNoLabel = this.$t('ticketDetail.ticketNo') || 'เลขที่ใบแจ้งซ่อม:';

          Swal.fire({
            icon: 'warning',
            title: title,
            html: `
              <div style="text-align: left; font-size: 0.95rem; line-height: 1.6;">
                <div><strong>${ticketNoLabel}</strong> <span class="text-primary font-weight-bold">${data.ticketNumber || '-'}</span></div>
                <div><strong>${techLabel}</strong> ${data.rejectedByName || '-'}</div>
                <div class="mt-2 p-2 bg-light border rounded text-danger">
                  <strong>${reasonLabel}</strong> ${data.reason || '-'}
                </div>
                <div class="mt-2 text-muted small">* ใบงานถูกส่งกลับมารายการรอมอบหมายเรียบร้อยแล้ว</div>
              </div>
            `,
            confirmButtonColor: '#145654',
            confirmButtonText: this.$t('login.ok') || 'รับทราบ'
          });
        });
      }
    },
    handleShowDetail(item) {
      let currentStep = 1;
      const statusMap = { 'pending': 1, 'assigned': 2, 'in_progress': 3, 'done': 4, 'welldone': 4 };
      currentStep = statusMap[item.status] || 1;
      this.isAssignMode = item.status === "pending";
      this.selectedReport = { ...item, currentStep };

      this.$nextTick(() => {
        const element = document.getElementById("detail-section");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    closeDetail() {
      this.selectedReport = null;
      this.isAssignMode = false;
    },
    handleTicketUpdated(updatedTicket) {
      if (this.selectedReport && updatedTicket && this.selectedReport._id === updatedTicket._id) {
        this.selectedReport = { ...this.selectedReport, ...updatedTicket };
      }
    },
    refreshTables() {
       if (this.activeTab === 'report') {
         if (this.$refs.ureportTable && typeof this.$refs.ureportTable.loadTickets === 'function') {
           this.$refs.ureportTable.loadTickets();
         }
       } else if (this.activeTab === 'history') {
         if (this.$refs.uhistoryTable && typeof this.$refs.uhistoryTable.loadHistoryTickets === 'function') {
           this.$refs.uhistoryTable.loadHistoryTickets();
         }
       }
    },
    handleTicketCreated() {
      if (this.$refs.ureportTable && typeof this.$refs.ureportTable.loadTickets === 'function') {
        this.$refs.ureportTable.loadTickets();
      }
      if (this.historyLoaded && this.$refs.uhistoryTable && typeof this.$refs.uhistoryTable.loadHistoryTickets === 'function') {
        this.$refs.uhistoryTable.loadHistoryTickets();
      }
    },
    async checkBeforeReport() {
      const userStr = localStorage.getItem('user');
      const userId = userStr ? JSON.parse(userStr)._id : null;
      if (!userId) {
        this.sendReportModal = true;
        return;
      }
      try {
        const response = await fetch(`${process.env.VUE_APP_APP_URL}/ticket/user/${userId}/active`);
        if (response.ok) {
          const data = await response.json();
          if (data.success && Array.isArray(data.data)) {
            const unevaluatedTicket = data.data.find(t => t.status === 'done');
            if (unevaluatedTicket) {
              Swal.fire({
                icon: 'warning',
                title: this.$t('mainuser.evalBeforeNewTitle'),
                text: this.$t('mainuser.evalBeforeNewText'),
                confirmButtonColor: '#2ba9a5',
                confirmButtonText: this.$t('login.ok'),
                returnFocus: false
              }).then(() => {
                this.handleShowDetail(unevaluatedTicket);
              });
              return;
            }
          }
        }
      } catch (err) {
        console.error("Error checking unevaluated tickets", err);
      }
      this.sendReportModal = true;
    }
  },
};
</script>

<style scoped>
.custom-tabs { margin-top: 10px; width: 100%; }
.tabs-scroll-container { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; padding-bottom: 5px; }
.tabs-header { display: flex; gap: 8px; border-bottom: 2px solid #e9ecef; margin-bottom: 15px; white-space: nowrap; min-width: 100%; }
.tab-item { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px 20px; border: none; background: transparent; color: #6c757d; cursor: pointer; border-bottom: 3px solid transparent; transition: all 0.2s ease; position: relative; bottom: -2px; font-size: 15px; font-weight: 500; flex-shrink: 0; }
.tab-item:hover { color: #495057; background: #f8f9fa; }
.tab-item.active { color: #ffffff !important; font-weight: 600; border-bottom-color: #2ba9a5; background-color: #2ba9a5; border-radius: 6px 6px 0 0; box-shadow: 0 -2px 5px rgba(0,0,0,0.05); }
.table-responsive-wrapper { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; }
.tab-icon { margin-right: 5px; }

.report-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 22px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
  transition: all 0.3s ease;
  animation: pulse-glow 2s ease-in-out infinite;
  white-space: nowrap;
}
.report-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5);
  animation: none;
}
.report-btn:active { transform: translateY(0); }
@keyframes pulse-glow {
  0%, 100% { box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4); transform: scale(1); }
  50% { box-shadow: 0 6px 30px rgba(16, 185, 129, 0.8), 0 0 50px rgba(16, 185, 129, 0.5); transform: scale(1.05); }
}

@media (max-width: 768px) {
  .tabs-header { gap: 0; justify-content: space-between; }
  .tab-item { flex: 1; padding: 10px 5px; font-size: 0.85rem; flex-direction: column; gap: 4px; height: auto; }
  .tab-icon { margin-right: 0; height: 20px; }
  .tab-text { font-size: 12px; white-space: normal; text-align: center; line-height: 1.2; }
  .card-body { padding: 10px !important; }
}
</style>

<style>
/* 1. เฉพาะมือถือและแท็บเล็ต (< 992px) */
@media (max-width: 991.98px) {
  /* บังคับเนื้อหาไม่ให้ขยับหนี */
  html:not([dir="rtl"]) .c-wrapper,
  html:not([dir="rtl"]) .c-main {
    margin-left: 0 !important;
    padding-left: 0 !important;
    transition: none !important;
  }
  
  /* บังคับ Sidebar ให้ลอยทับ */
  .c-sidebar {
    position: fixed !important;
    top: 66px !important;
    left: 0;
    bottom: 0;
    z-index: 1030 !important;
    box-shadow: 2px 0 10px rgba(0,0,0,0.3) !important;
  }

  /* ทำให้ Backdrop สีดำทำงาน */
  .c-sidebar-backdrop.c-show {
    opacity: 0.5 !important;
    z-index: 1020 !important;
  }
}

/* 2. เฉพาะหน้าจอคอมพิวเตอร์ (>= 992px) */
@media (min-width: 992px) {
  /* รีเซ็ตค่าให้กลับไปเป็นค่า Default ของ CoreUI */
  html:not([dir="rtl"]) .c-wrapper {
    margin-left: 0; /* ปล่อยให้ JS คำนวณเอง */
  }
  
  .c-sidebar {
    position: relative; /* กลับสู่สถานะปกติ */
    box-shadow: none;
  }
}
</style>